module.controller('virtualCtrl', ['$scope', '$state', '$http', '$rootScope', '$window', 'Session', 'baseURI', 'OVERLAY', '$stateParams', function ($scope, $state, $http, $rootScope, $window, Session, baseURI, OVERLAY, $stateParams){

  $scope.isExpense = Session.getExpense();
  $scope.parent = {};
  $scope.alert = {};
  $scope.copiedText = "-1";

  $scope.overlay = OVERLAY['member.home.virtual'];

  $scope.howToUseVirtualCards = function() {
    $state.go('member.home.profile/virtual.step1');
  };

  $scope.editAddress = function() {
      $state.go('member.home.profile.step1');
  };

  $scope.addToWallet= function() {
    $state.go('member.home.profile/wallet.step1');
  };

  $scope.copySuccess = function(e) {
    $scope.copiedText = e.text;
  };
}]);
